<template>
  <h3 class="pb5">Utilisation des statuts des ambulances - Sommaire (CDX_0270)</h3>
  <CritereRechercheServicesUrgence ref="critereRechercheServicesUrgence"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheServicesUrgence from "@/components/rapports/Rechercher/CritereRechercheServicesUrgence.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersAmbulanceSommaire",
  components: {ButtonBar, CritereRechercheServicesUrgence},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Services d'urgence");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheServicesUrgence.getCriteresRecherche();
      criteresRecherche.titre = "DossiersAmbulanceSommaire";
      criteresRecherche.nomRapport = "urgence.AmbulanceSommaireDossierGenerateurRapport_CDX_0270";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>

<style scoped>

</style>